import { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  DropPaycheck,
  DropPaycheckIcon,
  FileName,
  FormActions,
} from "./styled";
import DashboardCardWrapper from "components/Dashboard/Cards/Wrapper";
import { monthsOptions } from "utils/brazil";
import DashboardActions from "components/Dashboard/Actions";
import DashboardFormsCore from "../Core";
import DashboardFeedback from "components/Dashboard/Feedback";
import UploadFile from "components/Form/UploadFile";
import { numerize, typePaycheckOptions, yearOptions } from "utils";
import { toast } from "react-toastify";
import { CoreContext } from "context/CoreContext";
import { ConfirmationDialog } from "components/Modal";
import { uploadHolerite } from "services/holerite-upload";
import { sendNotificationMessage } from "services/notifications";
import { sendAceptedChangePlan, sendCancelChangePlan } from "services/plan";
import { ReadAction } from "services/logs";

export default function DashboardFormsPaycheckAdd() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);

  const refForm = useRef();
  const { currentCompany, user } = useContext(CoreContext);

  const actions = [
    { title: "Cancelar", outline: true, action: () => history.goBack() },
    { title: "Salvar", action: () => save(), loadable: true },
  ];

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [showLimitPayCheckModal, setShowLimitPayCheckModal] = useState(false);
  const [showInfoEventModal, setShowInfoEventModal] = useState(false);
  const [currentLimit, setCurrentLimit] = useState(null);
  const [replaceFile, setReplaceFile] = useState(null);

  console.log("currentLimit", currentLimit);

  const [formItems, setFormItems] = useState([]);

  const save = async () => {
    try {
      const values = refForm.current.getForm();
      if (!(values["year"] && values["month"] && values["type"])) {
        toast.error("Preencha todos os campos");
        return;
      }
      if (!selectedFile || !(selectedFile instanceof File)) {
        toast.error("Selecione um arquivo válido");
        return;
      }

      setLoading(true);

      const payload = {
        type: "holerite",
        payload: {
          "tipo-arquivo": currentCompany?.typeSheet || "2",
          cnpj: currentCompany?.cnpj?.replace(/[^\d]/g, ""),
          competencia: `${numerize(values["month"])}/${values["year"]}`,
          "tipo-holerite": values["type"],
        },
      };

      if (!payload.payload.cnpj) {
        throw new Error("CNPJ da empresa não encontrado");
      }

      if (!payload.payload["tipo-arquivo"]) {
        throw new Error("Tipo de arquivo não definido");
      }

      const tipoHolerite = payload.payload["tipo-holerite"];

      const result = await uploadHolerite(selectedFile, payload);

      if (result.message === "Holerite já existe com os dados fornecidos.") {
        setShowReplaceModal(true);
        setLoading(false);
        return;
      }

      // Verifica primeiro se é erro de limite excedido
      if (result.details?.limitExceeded) {
        const errorDetails = result.details.data;
        setCurrentLimit({
          changeDate: errorDetails.changeDate,
          companyCnpj: errorDetails.companyCnpj,
          companyId: errorDetails.companyId,
          companyName: errorDetails.companyName,
          newPlan: errorDetails.newPlan,
          oldPlan: errorDetails.oldPlan,
          totalEmployees: errorDetails.totalEmployees,
          limit: errorDetails.limit,
        });
        setShowLimitPayCheckModal(true);
        setLoading(false);
        return;
      }

      if (!result.success || result.error) {
        throw new Error(result.message || "Erro ao processar o arquivo");
      }

      // verificar os dados do result
      if (result.success && result.processInfo?.savedRecords > 0) {
        const logResult = await ReadAction(currentCompany?.id);
        if (logResult) {
          const normalizedData = logResult || [];

          // Se houver pelo menos 2 registros, comparar o campo "tipo-arquivo"
          if (normalizedData.length >= 2) {
            const getTipoHolerite = (normalizedData) => {
              // onde payload é uma string JSON
              try {
                const payloadStr = normalizedData.details?.body?.payload;
                if (payloadStr) {
                  const parsedPayload = JSON.parse(payloadStr);
                  return parsedPayload["tipo-arquivo"];
                }
              } catch (e) {
                console.error("Erro ao parsear payload:", e);
              }
              return null;
            };

            const tipoHoleriteRecente = getTipoHolerite(normalizedData[0]);
            const tipoHoleritePenultimo = getTipoHolerite(normalizedData[1]);

            if (
              tipoHoleriteRecente &&
              tipoHoleritePenultimo &&
              tipoHoleriteRecente !== tipoHoleritePenultimo
            ) {
              // Aciona o modal se os tipos forem diferentes
              setShowInfoEventModal(true);
            } else {
              toast.success("Holerites processados e cadastrados com sucesso.");
              history.goBack();
            }
          }
        }

        // Verifica se há pelo menos um token preenchido
        const hasValidToken =
          result.data &&
          result.data.some((item) => item.token && item.token.trim() !== "");

        if (hasValidToken) {
          // se estiver os dados do funcionario pegar uma lista com os tokens para a notificação push
          if (tipoHolerite !== "") {
            const selectedOption = typePaycheckOptions.find(
              (option) => option.id === tipoHolerite
            );
            if (selectedOption) {
              // Configuração de notificação
              const messageRequest = {
                TipoApp: 3, // Holerite
                Title: selectedOption.title,
                Body: `O seu ${selectedOption.title} já está disponível.`,
                ImgUrl: null,
                ImgBase64: null,
                ReenviarMarcacao: false,
                TokenList: result.data
                  .filter((item) => item.token && item.token.trim() !== "") // Verifica se o token não é null ou vazio
                  .map((item) => item.token), // Adiciona os tokens válidos
              };

              const messageResult = await sendNotificationMessage(
                messageRequest
              );

              // verificar os dados do result
              if (messageResult.success) {
                toast.success("Notificação enviada com sucesso.");
              }

              if (messageResult.error) {
                toast.error(
                  messageResult.message || "Erro ao enviar a notificação"
                );
              }
            } else {
              console.log(
                "Nenhum título encontrado para o tipoHolerite fornecido."
              );
            }
          }
        }
      } else {
        if (result.errors?.length > 0) {
          throw new Error(result.errors[0].message);
        }
        throw new Error(
          result.message ||
            "Erro ao processar o arquivo, verifique se os dados estão corretos."
        );
      }
    } catch (error) {
      console.error("Erro durante o salvamento:", error);
      toast.error(
        error.message || "Ocorreu um erro inesperado durante o processo."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReplaceConfirm = async () => {
    try {
      if (!replaceFile) {
        toast.error("Selecione o novo arquivo para substituição");
        return;
      }

      setLoading(true);
      const values = refForm.current.getForm();

      const payload = {
        type: "holerite",
        payload: {
          "tipo-arquivo": currentCompany?.typeSheet,
          cnpj: currentCompany?.cnpj?.replace(/\.|\-|\//g, ""),
          competencia: `${numerize(values["month"])}/${values["year"]}`,
          "tipo-holerite": values["type"],
          replace: true,
        },
      };

      const result = await uploadHolerite(replaceFile, payload);
      console.log("🚀 ~ handleReplaceConfirm ~ result:", result);

      if (result.error) {
        throw new Error(result.message || "Erro ao substituir o holerite");
      }

      toast.success("Holerite substituído com sucesso");
      history.goBack();
    } catch (error) {
      console.error("Erro ao substituir holerite:", error);
      toast.error(error.message || "Erro ao substituir o holerite");
    } finally {
      setLoading(false);
      setShowReplaceModal(false);
      setReplaceFile(null);
    }
  };

  // método para confirmar a alteração de plano
  const handleAcpetedChangePlan = async () => {
    setLoading(true);

    try {
      if (currentLimit) {
        const payload = {
          type: "plan",
          payload: {
            companyId: currentLimit.companyId,
            companyCnpj: currentLimit.companyCnpj,
            companyName: currentLimit.companyName,
            newPlan: currentLimit.newPlan,
            oldPlan: currentLimit.oldPlan,
            totalEmployees: currentLimit.totalEmployees,
            userName: user.username,
            userEmail: user.email,
          },
        };

        // Aqui você pode adicionar a lógica para atualizar o plano
        const messageResult = await sendAceptedChangePlan(payload);

        // verificar os dados do result
        if (messageResult.success) {
          toast.success(
            "Alteração de plano concluída com sucesso. Agora pode importar holerites novamente"
          );
        }

        if (messageResult.error) {
          toast.error(messageResult.message || "Erro ao alterar o plano");
        }
      }

      setShowLimitPayCheckModal(false);
      //history.goBack();
    } catch (error) {
      console.error("Erro ao aceitar mudança de plano:", error);
      toast.error("Erro ao processar solicitação de mudança de plano");
    } finally {
      setLoading(false); // Libera novamente após a conclusão da requisição
      save(); // Chama o método save após a alteração do plano
    }
  };

  // método paa cancelar a alteração de plano
  const handleCancelChangePlan = async () => {
    setLoading(true);

    try {
      // Aqui você pode adicionar a lógica para atualizar o plano

      if (currentLimit) {
        const payload = {
          type: "plan",
          payload: {
            companyCnpj: currentLimit.companyCnpj,
            companyName: currentLimit.companyName,
            newPlan: currentLimit.newPlan,
            oldPlan: currentLimit.oldPlan,
            totalEmployees: currentLimit.totalEmployees,
            userName: user.username,
            userEmail: user.email,
          },
        };

        const messageResult = await sendCancelChangePlan(payload);

        // verificar os dados do result
        if (messageResult.status) {
          toast.info(
            "A alteração de plano não foi realizada. Não é possível importar os holerites com o plano atual."
          );
        }

        if (messageResult.error) {
          toast.error(messageResult.message || "Erro ao alterar o plano");
        }
      }
      setShowLimitPayCheckModal(false);
      //history.goBack();
    } catch (error) {
      console.error("Erro ao aceitar cancelamento de mudança de plano:", error);
      toast.error(
        "Erro ao processar cancelamento de solicitação de mudança de plano"
      );
    } finally {
      setLoading(false); // Libera novamente após a conclusão da requisição
    }
  };

  const ReplaceModalContent = () => (
    <>
      <p>
        Já existe um holerite lançado para este período. Deseja substituir o
        arquivo existente?
      </p>
      <UploadFile forwardRepo onChange={(e) => setReplaceFile(e)}>
        <DropPaycheck>
          <DropPaycheckIcon />
          {replaceFile?.name || "Adicionar novo arquivo"}
        </DropPaycheck>
      </UploadFile>
    </>
  );

  const formatCurrency = (value, locale = "pt-BR", currency = "BRL") => {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    }).format(value);
  };

  const LimitPaycheckModalContent = () => (
    <>
      <p>Você atingiu o limite de funcionários do seu plano atual.</p>
      <p>Plano atual: {currentLimit?.oldPlan.name} funcionários</p>
      <p>Valor atual: {formatCurrency(currentLimit?.oldPlan.value)}</p>
      <p>
        Quantidade atual de funcionários: {currentLimit?.totalEmployees}{" "}
        funcionários
      </p>
      <p>Novo Plano: {currentLimit?.newPlan.name} funcionários</p>
      <p>Novo Valor: {formatCurrency(currentLimit?.newPlan.value)}</p>
      <p>É necessário atualizar seu plano para continuar.</p>
      <strong>Deseja prosseguir com a atualização do plano?</strong>
    </>
  );

  const NewEventsModalContent = () => (
    <>
      <p>O seu holerite foi alterado para uma nova folha.</p>
      <p>Os primeiros eventos da nova folha serão ativados automaticamente.</p>
      <p>
        Caso necessário altere os eventos ativos para que mostre as informações
        desejadas na tela de valores.
      </p>
    </>
  );

  useEffect(() => {
    setFormItems([
      { placeholder: "Ano", ref: "year", options: yearOptions, quarter: true },
      {
        placeholder: "Mês",
        ref: "month",
        options: [...monthsOptions],
        quarter: true,
      },
      {
        placeholder: "Tipo de holerite",
        ref: "type",
        options: typePaycheckOptions,
        quarter: true,
      },
      {
        placeholder: "Holerite",
        ref: "type",
        custom: selectedFile?.name ? (
          <DropPaycheck onClick={() => setSelectedFile(null)}>
            <FileName>{selectedFile?.name}</FileName> <DropPaycheckIcon close />
          </DropPaycheck>
        ) : (
          <UploadFile forwardRepo onChange={(e) => setSelectedFile(e)}>
            <DropPaycheck>
              <DropPaycheckIcon /> Adicionar arquivo{" "}
            </DropPaycheck>
          </UploadFile>
        ),
        quarter: true,
      },
    ]);
  }, [selectedFile]);

  return (
    <>
      <DashboardCardWrapper backable title={"Novo holerite"} white>
        {feedback ? (
          <DashboardFeedback
            message={"Holerites cadastrados com sucesso"}
            type={"success"}
          />
        ) : null}
        <DashboardFormsCore formItems={formItems} ref={refForm} />
        <FormActions>
          <DashboardActions actions={actions} loading={loading} />
        </FormActions>
      </DashboardCardWrapper>

      <ConfirmationDialog
        open={showReplaceModal}
        title="Substituir Holerite"
        onCancel={() => {
          setShowReplaceModal(false);
          setReplaceFile(null);
        }}
        onConfirm={handleReplaceConfirm}
        btnCancelText="Cancelar"
        btnConfirmText="Confirmar"
      >
        <ReplaceModalContent />
      </ConfirmationDialog>

      {/* Modal informativo para os eventos */}
      <ConfirmationDialog
        open={showInfoEventModal}
        title="Ajuste na seleção dos eventos"
        onConfirm={() => {
          setShowInfoEventModal(false);
          toast.success("Holerites processados e cadastrados com sucesso.");
          history.goBack(); // Navega para trás após o modal ser fechado (caso seja necessário)
        }}
        confirmText="Ok" // Utilizamos o botão de cancelamento como "Ok"
      >
        <NewEventsModalContent />
      </ConfirmationDialog>

      <ConfirmationDialog
        open={showLimitPayCheckModal}
        title="Limite de Funcionários Excedido"
        onCancel={handleCancelChangePlan}
        onConfirm={handleAcpetedChangePlan}
        btnCancelText="Não"
        btnConfirmText="Sim"
      >
        <LimitPaycheckModalContent />
      </ConfirmationDialog>
    </>
  );
}
